import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/translation.json";
import bg from "./locales/bg/translation.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: { translation: en },
      bg: { translation: bg },
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
